module.exports = __webpack_public_path__ + "img/operation_drag.d11c070c.svg";